import { render, staticRenderFns } from "./bank-statement-pending.vue?vue&type=template&id=45eef84c&"
import script from "./bank-statement-pending.vue?vue&type=script&lang=js&"
export * from "./bank-statement-pending.vue?vue&type=script&lang=js&"
import style0 from "./bank-statement-pending.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports